import React, { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Footer from "../Footer";
import NavigationBar from "../navigation/NavigationBar";
import SidebarAdmin from "../sidebars/SidebarAdmin";
import AdminLogo from "../../img/user/admin.png";
import ClinicianLogo from "../../img/user/clinician.png";
import PatientLogo from "../../img/user/patient.png";
import InfoTabPatient from "../sharedInfoPageTabs/InfoTabPatient";
import InfoTabClinician from "../sharedInfoPageTabs/InfoTabClinician";
import InfoTabClinicAdmin from "../sharedInfoPageTabs/InfoTabClinicAdmin";

interface InformationPageAdminProps {
  title: string;
}

const InformationPageAdmin = ({ title }: InformationPageAdminProps) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return (
    <div className="header-fixed" id="body">
      {/* navigation bar (bar on the top) */}
      <NavigationBar />
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar (bar on the side) */}
          <SidebarAdmin />
          {/* Content */}
          <div className="col container p-3" id="main-content">
            <h3>Informationen zu SysDok</h3>
            <Tabs defaultActiveKey="admin" className="mb-3">
              {/* for admins/ Für Administrator*innen */}
              <Tab
                eventKey="admin"
                title={
                  <>
                    <i className="mdi">
                      <img
                        className="rounded-circle "
                        src={AdminLogo}
                        width="25px"
                        alt="Admin"
                      />
                    </i>
                    <span> Für Administrator*innen</span>
                  </>
                }
              >
                <div className="m-3">
                  <InfoTabClinicAdmin />
                </div>
              </Tab>
              {/* for employees/ Für Mitarbeitende */}
              <Tab
                eventKey="clinician"
                title={
                  <div>
                    <i className="mdi">
                      <img
                        className="rounded-circle "
                        src={ClinicianLogo}
                        width="25px"
                        alt="Clinician"
                      />
                    </i>
                    <span> Für Mitarbeitende</span>
                  </div>
                }
              >
                <div className="m-3">
                  <InfoTabClinician />
                </div>
              </Tab>
              {/* for patients/ Für Patient*innen */}
              <Tab
                eventKey="patient"
                title={
                  <div>
                    <i className="mdi">
                      <img
                        className="rounded-circle "
                        src={PatientLogo}
                        width="25px"
                        alt="Patient"
                      />
                    </i>
                    <span> Für Patient*innen</span>
                  </div>
                }
              >
                <div className="m-3">
                  <InfoTabPatient />
                </div>
              </Tab>
            </Tabs>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};
export default InformationPageAdmin;
